var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "main-content" },
    [
      _c("pulse-loader", {
        staticClass: "text-center",
        attrs: { loading: _vm.loading, color: _vm.loadingColor },
      }),
      _vm._v(" "),
      !_vm.loading
        ? _c("div", { staticClass: "card" }, [
            _vm._m(0),
            _vm._v(" "),
            _c("div", { staticClass: "card-body" }, [
              _c("table", { staticClass: "table table-hover table-sm" }, [
                _vm._m(1),
                _vm._v(" "),
                _c(
                  "tbody",
                  _vm._l(
                    _vm.sortArray(_vm.records, "order"),
                    function (record) {
                      return _c("tr", [
                        _c("td", [
                          _vm._v(
                            "(" +
                              _vm._s(record.id) +
                              ") " +
                              _vm._s(record.title)
                          ),
                        ]),
                        _vm._v(" "),
                        _c("td", [_vm._v(_vm._s(record.start))]),
                        _vm._v(" "),
                        _c("td", [_vm._v(_vm._s(record.end))]),
                        _vm._v(" "),
                        _c("td"),
                      ])
                    }
                  ),
                  0
                ),
              ]),
            ]),
          ])
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "card-header" }, [
      _c("h5", [_vm._v("Рабочее время смен")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("thead", [
      _c("tr", [
        _c("th", [_vm._v("Название смены")]),
        _vm._v(" "),
        _c("th", [_vm._v("Начало")]),
        _vm._v(" "),
        _c("th", [_vm._v("Конец")]),
        _vm._v(" "),
        _c("th"),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }